// Central SEO data for VTCodex – edit here, every page picks it up.
export const SITE = {
  url: 'https://vtcodex.com',
  name: 'VTCodex',
  legalName: 'VTCodex',
  logo: 'https://vtcodex.com/logo.jpeg',
  ogImage: 'https://vtcodex.com/logo.jpeg',
  email: 'contact@vtcodex.com',
  phones: ['+919306468015', '+919729013924', '+919499130923'],
  locale: 'en_IN',
  socials: [
    'https://www.linkedin.com/company/vtcodex/',
    'https://www.instagram.com/_vtcodex/',
    'https://x.com/_VTCODEX',
    'https://facebook.com/vtcodex',
  ],
};

export const FOUNDER = {
  '@type': 'Person',
  '@id': 'https://vtcodex.com/team#vishal-rana',
  name: 'Vishal Rana',
  alternateName: ['Vishal', 'Mr. Vishal', 'Vishal Rana VTCodex', 'Vishal VTCodex'],
  jobTitle: 'Founder & CEO',
  description: 'Vishal Rana is the Founder of VTCodex – a website development, mobile app and digital solutions company in India.',
  url: 'https://vtcodex.com/team',
  image: 'https://vtcodex.com/logo.jpeg',
  telephone: '+919729013924',
  worksFor: { '@id': 'https://vtcodex.com/#organization' },
  sameAs: ['https://www.linkedin.com/in/vishalrana227'],
  knowsAbout: ['Web Development', 'Mobile App Development', 'React', 'Node.js', 'SEO'],
};

export const COFOUNDER = {
  '@type': 'Person',
  '@id': 'https://vtcodex.com/team#tanisha-garg',
  name: 'Tanisha Garg',
  alternateName: ['Tanisha', 'Ms. Tanisha', 'Tanisha Garg VTCodex', 'Tanisha VTCodex'],
  jobTitle: 'Co-Founder',
  description: 'Tanisha Garg is the Co-Founder of VTCodex – a website development, mobile app and digital solutions company in India.',
  url: 'https://vtcodex.com/team',
  image: 'https://vtcodex.com/logo.jpeg',
  telephone: '+919306468015',
  worksFor: { '@id': 'https://vtcodex.com/#organization' },
  sameAs: ['https://www.linkedin.com/in/tanisha-garg-70116b313'],
  knowsAbout: ['Web Design', 'User Experience', 'React', 'Digital Solutions'],
};

export const ORGANIZATION = {
  '@context': 'https://schema.org',
  '@type': ['Organization', 'ProfessionalService'],
  '@id': 'https://vtcodex.com/#organization',
  name: 'VTCodex',
  alternateName: ['VT Codex', 'VTCodeX', 'vtcodex.com'],
  url: SITE.url,
  logo: SITE.logo,
  image: SITE.logo,
  email: SITE.email,
  telephone: SITE.phones,
  description: 'VTCodex is an Indian software company offering website development, Android app development, backend development, payment gateway integration, SEO and hosting. Founded by Vishal Rana and Tanisha Garg.',
  slogan: 'Modern Digital Solutions – Websites & Apps',
  areaServed: [{ '@type': 'Country', name: 'India' }, { '@type': 'Place', name: 'Worldwide' }],
  address: { '@type': 'PostalAddress', addressCountry: 'IN', addressRegion: 'Haryana' },
  priceRange: '₹₹',
  openingHours: 'Mo-Sa 09:00-20:00',
  founder: { '@id': FOUNDER['@id'] },
  employee: [{ '@id': COFOUNDER['@id'] }],
  sameAs: SITE.socials,
  makesOffer: [
    'Website Development', 'Mobile App Development', 'Backend Development',
    'Payment Gateway Integration', 'SEO Optimization', 'Domain & Hosting', 'Website Deployment',
  ].map(n => ({ '@type': 'Offer', itemOffered: { '@type': 'Service', name: n } })),
};
// co-founder as schema.org "founder" too (schema allows multiple)
ORGANIZATION.founder = [{ '@id': FOUNDER['@id'] }, { '@id': COFOUNDER['@id'] }];
delete ORGANIZATION.employee;

export const WEBSITE = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': 'https://vtcodex.com/#website',
  url: SITE.url,
  name: 'VTCodex',
  alternateName: 'VTCodex – Founded by Vishal Rana & Tanisha Garg',
  publisher: { '@id': 'https://vtcodex.com/#organization' },
  inLanguage: 'en-IN',
};

export const PEOPLE_GRAPH = {
  '@context': 'https://schema.org',
  '@graph': [FOUNDER, COFOUNDER],
};

export const APPS_SCHEMA = [
  {
    name: 'VTCodeX Restro',
    desc: 'Table-wise restaurant billing app with menu management, GST and cash/UPI/card settlement.',
    url: 'https://play.google.com/store/apps/details?id=com.vtcodexrestro',
    cat: 'BusinessApplication',
  },
  {
    name: 'Rasdhara',
    desc: 'Cattle feed ordering app with real-time push notifications and order status updates.',
    url: 'https://play.google.com/store/apps',
    cat: 'ShoppingApplication',
  },
].map(a => ({
  '@context': 'https://schema.org',
  '@type': 'MobileApplication',
  name: a.name,
  description: a.desc,
  operatingSystem: 'ANDROID',
  applicationCategory: a.cat,
  downloadUrl: a.url,
  url: a.url,
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'INR' },
  author: { '@id': 'https://vtcodex.com/#organization' },
  publisher: { '@id': 'https://vtcodex.com/#organization' },
}));
